export const home = {
  name: 'Home',
  strapline: 'Be inspired to make home improvements',
  frequency: 'monthly',
  code: 'hme',
  salesforceName: 'home',
  editor: {
    name: 'Hannah Healey',
    role: 'Home improvements writer',
    src: 'https://media.product.which.co.uk/prod/images/original/ccbf35025975-image-20260323-112632.png',
  },
}

export const tech = {
  name: 'Tech',
  strapline: "News, deals and stuff the manuals don't tell you",
  frequency: 'monthly',
  code: 'tec',
  salesforceName: 'tech_support', // we need to keep this - refer WHC-1185
  editor: {
    name: 'Lisa Barber',
    role: 'Technology editor',
    src: 'https://media.product.which.co.uk/prod/images/original/b96e2c18fa2b-image-28.png',
  },
}

export const foodAndHealth = {
  name: 'Healthy Living',
  strapline: 'Eat right, live well and stay healthy',
  code: 'fah',
  frequency: 'monthly',
  salesforceName: 'food_and_health',
  editor: {
    name: 'Jessica Carson',
    role: 'Food & health editor',
    src: 'https://media.product.which.co.uk/prod/images/original/415253871114-image-28-6.png',
  },
}

export const weeklyScoop = {
  name: 'Weekly Scoop',
  strapline: 'Make smarter consumer choices',
  frequency: 'weekly',
  code: 'scp',
  salesforceName: 'weekly_scoop',
}

export const gardening = {
  name: 'Gardening',
  strapline: 'Breathe new life into your outside spaces',
  frequency: 'monthly',
  code: 'gdn',
  salesforceName: 'gardening',
  editor: {
    name: 'Ceri Thomas',
    role: 'Gardening editor',
    src: 'https://media.product.which.co.uk/prod/images/original/7c967c59c281-image-28-4.png',
  },
}

export const deals = {
  name: 'Deals',
  strapline: 'Know about deals and grab genuine bargains',
  frequency: 'monthly and for sales',
  code: 'dea',
  salesforceName: 'deals',
  editor: {
    name: 'Faith Strickland',
    role: 'Deals editor',
    src: 'https://media.product.which.co.uk/prod/images/original/738d49bc9fb2-image-28-3.png',
  },
}

export const cars = {
  name: 'Cars',
  strapline: 'Use our easy-win driving tips to save money, drive smarter and cut your costs',
  frequency: 'monthly',
  code: 'crs',
  salesforceName: 'cars',
  editor: {
    name: 'Michael Passingham',
    role: 'Car expert',
    src: 'https://media.product.which.co.uk/prod/images/original/0b79245b7d6f-image-28-2.png',
  },
}

export const money = {
  name: 'Money',
  strapline: 'Find ways to make and save extra cash and how you can manage your finances',
  frequency: 'weekly',
  code: 'mny',
  salesforceName: 'money',
}

export const travel = {
  name: 'Travel',
  strapline: 'Start planning better holidays and find inspiring year-round UK trip ideas',
  code: 'tvl',
  frequency: 'monthly',
  salesforceName: 'travel',
  editor: {
    name: 'Rory Boland',
    role: 'Travel editor',
    src: 'https://media.product.which.co.uk/prod/images/original/feaf16779a08-image-28-1.png',
  },
}

export const sustainability = {
  name: 'Greener Living',
  strapline: 'Make changes for the planet and your pocket',
  code: 'sus',
  frequency: 'monthly',
  salesforceName: 'sustainability',
  editor: {
    name: 'Emily Seymour',
    role: 'Sustainability editor',
    src: 'https://media.product.which.co.uk/prod/images/original/23f0f60e9464-image-28-9.png',
  },
}

export const scamAlerts = {
  name: 'Scam Alerts',
  strapline: 'Outsmart the fraudsters, spot and avoid scams',
  code: 'scm',
  frequency: 'weekly',
  salesforceName: 'scams',
  editor: {
    name: 'Tali Ramsey',
    role: 'Consumer rights expert',
    src: 'https://media.product.which.co.uk/prod/images/original/3e264c2015f0-image-28-7.png',
  },
}

export const retirement = {
  name: 'Retirement Planning',
  strapline: 'Get your finances ready for the future',
  code: 'rin',
  frequency: 'monthly',
  salesforceName: 'retirement_income',
  editor: {
    name: 'Holly Lanyon',
    role: 'Money expert',
    src: 'https://media.product.which.co.uk/prod/images/original/25e436bea279-image-28-5.png',
  },
}

export const firstTimeBuyer: NewsletterData = {
  name: 'First-time Buyer',
  strapline:
    'Sign up for our series of free weekly newsletters to help you get on the property ladder',
  code: 'ftb',
  frequency: 'weekly',
  salesforceName: 'first_time_buyer',
  editor: {
    name: 'Sam Wilson',
    role: 'Which? mortgages and property expert',
    src: 'https://media.product.which.co.uk/prod/images/original/4c12dc4a9626-sam-wilsonglide-portrait-1.jpg',
  },
}

export const newslettersOrderedByPopularity: NewsletterData[] = [
  home,
  tech,
  foodAndHealth,
  weeklyScoop,
  gardening,
  deals,
  cars,
  money,
  travel,
  sustainability,
  scamAlerts,
  retirement,
  firstTimeBuyer,
]

export const newsletterSfNameMap = new Map(
  newslettersOrderedByPopularity.map((newsletter) => [newsletter.salesforceName, newsletter])
)

export type NewsletterData = {
  name: string
  strapline: string
  frequency: string
  code: string
  salesforceName: string
  editor?: {
    name: string
    role: string
    src: string
  }
}
